module.exports = __webpack_public_path__ + "img/mylik.608b13ee.png";